import { type ReactElement } from 'react'
import { Tooltip } from '@dhl-ui/components'
import { type PageMenuItem } from './types'

type Props = {
  children: ReactElement

  /**
   * is our main menu expanded or not
   */
  isExpanded: boolean
} & Pick<PageMenuItem, 'label'>

export const MainMenuItemTooltip = ({ children, label, isExpanded }: Props) =>
  isExpanded ? (
    children
  ) : (
    <Tooltip title={label} placement="right">
      {children}
    </Tooltip>
  )
